import { __awaiter } from "tslib";
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { RECENTLY_UPDATED_ARTICLES_VARIANTS } from 'pathfinder/rules-engine/modules/recentlyUpdatedArticlesModule';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { getRecentlyUpdatedArticlesData } from './helpers/getRecentlyUpdatedArticles';
const OPTIMIZELY_VARIABLES = {
    EXPERIMENT_ENABLED: 'optimizely_enable_recently_updated_articles_experiment',
    EXPERIMENT_VARIANT: 'optimizely_experiment_recently_updated_articles_variant_name',
};
export const getRecentlyUpdatedArticlesModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const variant = yield getOptimizelyVariant(isForced, OPTIMIZELY_VARIABLES, RECENTLY_UPDATED_ARTICLES_VARIANTS);
    if (!variant) {
        return null;
    }
    const data = yield getRecentlyUpdatedArticlesData();
    if (!data) {
        return;
    }
    const moduleProps = buildModuleProps(moduleConfig, { variant, data });
    const { log } = moduleProps;
    try {
        const reactRoot = document.createElement('div');
        if (variant.includes('desktop')) {
            const stickyModulesWrapper = document.querySelector('.sticky-modules-wrapper');
            if (!stickyModulesWrapper) {
                return;
            }
            stickyModulesWrapper === null || stickyModulesWrapper === void 0 ? void 0 : stickyModulesWrapper.insertAdjacentElement('beforebegin', reactRoot);
        }
        if (variant.includes('mobile')) {
            const infobox = document.querySelector('.portable-infobox-wrapper');
            if (!infobox) {
                return;
            }
            infobox === null || infobox === void 0 ? void 0 : infobox.after(reactRoot);
        }
        const RecentlyUpdatedArticlesModule = lazy(() => import('./RecentlyUpdatedArticlesModule'));
        const lazyComponent = () => {
            return (React.createElement("div", null,
                React.createElement(Suspense, { fallback: React.createElement("div", { style: { height: '255px' } }) },
                    React.createElement(RecentlyUpdatedArticlesModule, Object.assign({}, moduleProps)))));
        };
        const render = () => {
            ReactDOM.render(React.createElement(lazyComponent, moduleProps), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('RecentlyUpdatedArticlesModule error', error);
    }
    return null;
});
